/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/member-ordering */
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatAccordion } from "@angular/material/expansion";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FetchData, imgHeaderDataNew } from "app/shared/generalMethods";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DatePipe } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, finalize, throwError } from "rxjs";
import { ParentPortalService } from "app/services/parentPortal.service";

interface RegistrationSchedule {
  totalDue: number;
  programFee: number;
  programDescription: string;
  kidsName: string;
  notes: string;
  attendanceStatus: string;
  feesPaid: number;
  kidsId: string;
  createdDate: string;
  classSchedule: string;
  programDate: string;
  isCancelled: string;
}

@Component({
  selector: "app-history",
  templateUrl: "./history.component.html",
  styleUrls: ["./history.component.scss"],
  providers: [DatePipe],
})
export class HistoryComponent implements OnInit, AfterViewInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild("historyTable") historyTable!: ElementRef;

  historyForm: FormGroup;
  displayedColumns: string[] = [
    "programDescription",
    "kidsName",
    "attendanceStatus",
    "programFee",
    "totalDue",
    "notes",
  ];
  scheduleData: RegistrationSchedule[] = [];
  filteredScheduleData: RegistrationSchedule[] = [];
  parentId: string;
  kids: any[] = [];
  classScheduleMap: Record<string, string> = {};
  selectedKid: string = "all";
  selectedStatus: string = "all";
  pdfObj: jsPDF = new jsPDF();
  kidsId: any[] = [];
  kidsName: any[] = [];
  physicalAddress: string = "";
  postalCode: string = "";
  townCity: string = "";
  parentName: string = "";

  constructor(
    private fb: FormBuilder,
    private fetchData: FetchData,
    private datePipe: DatePipe,
    private _snackBar: MatSnackBar,
    private parentPortalService: ParentPortalService
  ) {}

  ngOnInit(): void {
    this.initHistoryForm();
    this.parentId = this.fetchData.parentId;
    this.filterKidsByParentId();
    this.loadSchedules();
    this.loadParentData();
    this.setInitialDateRange();
  }

  onPanelOpened(): void {
    this.applyFilters();
  }

  private setInitialDateRange(): void {
    let filteredData = this.scheduleData;
    const today = new Date();
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);

    const formattedToday = this.datePipe.transform(today, "yyyy-MM-dd");
    const formattedOneWeekAgo = this.datePipe.transform(
      oneWeekAgo,
      "yyyy-MM-dd"
    );

    this.historyForm.patchValue({
      fromDate: formattedOneWeekAgo,
      toDate: formattedToday,
    });

    if (this.selectedKid !== "all") {
      filteredData = filteredData.filter(
        (schedule) => schedule.kidsId === this.selectedKid
      );
    }
  }

  ngAfterViewInit(): void {
    if (!this.historyTable) {
      console.error("historyTable element reference not initialized");
    }
  }

  private initHistoryForm(): void {
    this.historyForm = this.fb.group({
      fromDate: ["", Validators.required],
      toDate: ["", Validators.required],
    });
  }

  private filterKidsByParentId(): void {
    const lstKids = this.fetchData.data?.lstKids || [];
    this.kids = lstKids.filter((kid) => kid.Parent__c === this.parentId);
    this.kidsId = this.kids.map((kid) => kid.Id);
    this.kidsName = this.kids.map((kid) => kid.Kid_name__c);
  }

  private loadParentData(): void {
    const lstParent = this.fetchData.data?.lstParents || [];
    if (lstParent.length > 0) {
      const parent = lstParent[0];
      this.physicalAddress = parent.Physical_Address__c || "N/A";
      this.postalCode = parent.Postal_Code__c || "N/A";
      this.townCity = parent.Town_City__c || "N/A";
      this.parentName = parent.Name || "N/A";
    } else {
      console.warn("No parent data found in lstParent.");
    }
  }

  private loadSchedules(): void {
    const lstRegistrationSchedules =
      this.fetchData.data?.lstRegistrationSchedules || [];
    const lstAttendance = this.fetchData.data?.lstAttendance || [];
    this.scheduleData = lstRegistrationSchedules.map((schedule) => ({
      programDescription: schedule.Class_Schedule__r?.Name,
      attendanceStatus: schedule.Is_Cancelled__c
        ? "Cancelled"
        : schedule.Status__c,
      feesPaid: schedule.Paid_Fee__c ?? 0,
      programFee: schedule.Program_Fee__c ?? 0,
      cancellationFee: schedule.Cancellation_Fees__c ?? 0,
      totalDue: schedule.Total_Due__c,
      kidsId: schedule.Kids__c,
      kidsName: schedule.Kid_name__c,
      notes: schedule.Notes__c,
      createdDate: schedule.CreatedDate,
      classSchedule: schedule.Class_Schedule__c,
      programDate: schedule.Program_Date__c,
      isCancelled: schedule.Is_Cancelled__c,
    }));
    this.processAttendance(lstAttendance, lstRegistrationSchedules);
    this.filteredScheduleData = [...this.scheduleData];
  }

  applyFilters(): void {
    const fromDate = this.historyForm.get("fromDate")?.value;
    const toDate = this.historyForm.get("toDate")?.value;

    let filteredData = this.scheduleData;

    if (this.selectedKid !== "all") {
      filteredData = filteredData.filter(
        (schedule) => schedule.kidsId === this.selectedKid
      );
    }

    this.onKidSelectionChange();

    filteredData = filteredData.filter((schedule) => {
      const match = schedule.programDate.match(/\d{4}-\d{2}-\d{2}/);
      if (!match) {
        return false;
      }

      const programDate = new Date(match[0]);

      const normalizedProgramDate = new Date(programDate.setHours(0, 0, 0, 0));
      const normalizedFromDate = fromDate
        ? new Date(new Date(fromDate).setHours(0, 0, 0, 0))
        : null;
      const normalizedToDate = toDate
        ? new Date(new Date(toDate).setHours(0, 0, 0, 0))
        : null;

      if (normalizedFromDate && normalizedFromDate > normalizedProgramDate) {
        return false;
      }
      if (normalizedToDate && normalizedToDate < normalizedProgramDate) {
        return false;
      }
      return true;
    });

    if (this.selectedStatus !== "all") {
      filteredData = filteredData.filter(
        (schedule) => schedule.attendanceStatus === this.selectedStatus
      );
    }

    this.filteredScheduleData = filteredData;
    if (this.filteredScheduleData.length === 0) {
      this.openSnackBar("No Data Found");
    }
  }

  resetFilters(): void {
    this.historyForm.reset();
    this.selectedKid = "all";
    this.selectedStatus = "all";
    this.filteredScheduleData = this.scheduleData;
  }

  onKidSelectionChange(): void {
    if (this.selectedKid === "all") {
      this.filteredScheduleData = [...this.scheduleData];
    } else {
      this.filteredScheduleData = this.scheduleData.filter(
        (schedule) => schedule.kidsId === this.selectedKid
      );
    }
    if (this.filteredScheduleData.length === 0) {
      console.warn(
        `No data available for the selected kid with ID: ${this.selectedKid}`
      );
    }
  }

  getSelectedKidName(): string {
    const kid = this.kids.find((k) => k.Id === this.selectedKid);
    return kid ? kid.Name : "All Kids";
  }

  generatePDF(): void {
    this.pdfObj = new jsPDF();
    const pdfWidth = this.pdfObj.internal.pageSize.getWidth();
    const pdfHeight = this.pdfObj.internal.pageSize.getHeight();
    const centerX = pdfWidth / 2;

    // --- Parent Details ---
    const parentDetails = [
      { label: "Parent Name:", value: this.parentName },
      { label: "Physical Address:", value: this.physicalAddress },
      { label: "Postal Code:", value: this.postalCode },
      { label: "Town/City:", value: this.townCity },
    ];

    const parentTableHeaders = ["Parent Information", ""];
    const parentTableData = parentDetails.map((detail) => [
      detail.label,
      detail.value,
    ]);

    // --- Header (on every page) ---
    const addMainHeader = (pdf: jsPDF) => {
      pdf.addImage(imgHeaderDataNew, "PNG", 16, 6, 62, 15);
      pdf.setFontSize(14);
      pdf.setTextColor(40);
      pdf.setFont("helvetica", "bold");
      pdf.text("Attendance & Program History Report", centerX, 30, {
        align: "center",
      });
      pdf.setDrawColor(150);
      pdf.setLineWidth(0.5);
      pdf.line(20, 35, pdf.internal.pageSize.getWidth() - 20, 35);
    };

    // --- Footer (every page) ---
    const addFooter = (pdf: jsPDF, currentPage: number, totalPages: number) => {
      const width = pdf.internal.pageSize.getWidth();
      const height = pdf.internal.pageSize.getHeight();
      pdf.setDrawColor(200);
      pdf.line(20, height - 20, width - 20, height - 20);
      pdf.setFontSize(8);
      pdf.setTextColor(90);
      pdf.text("TrailFusion", 20, height - 15);
      pdf.text(
        "Tel: (437)-225-2458 | 4045 Industrial Drive Unit A Windsor ON N9C 3R8 Canada | Email: info@trailfusion.net",

        20,
        height - 10
      );
      pdf.text(`Page ${currentPage} of ${totalPages}`, width - 40, height - 15);
    };

    // --- Table Data ---
    const tableHeaders = [
      "Program & Schedule",
      "Kid",
      "Status",
      "Fee",
      "Total Due",
      "Notes",
    ];
    const tableData = this.filteredScheduleData.map((row) => [
      row.programDescription,
      row.kidsName,
      row.attendanceStatus,
      `$${row.programFee.toFixed(2)}`,
      `$${row.totalDue.toFixed(2)}`,
      row.notes,
    ]);

    let currentPage = 1;
    let startY = 40;
    const firstPageRows = 15;
    const otherPageRows = 22;
    const totalPages = Math.ceil(
      (this.filteredScheduleData.length - firstPageRows) / otherPageRows + 1
    );

    while (tableData.length > 0) {
      const rowsPerPage = currentPage === 1 ? firstPageRows : otherPageRows;

      if (currentPage > 1) {
        this.pdfObj.addPage();
        startY = 40;
      }

      // ✅ Add header on every page
      addMainHeader(this.pdfObj);

      // 📄 Add parent info table on first page only
      if (currentPage === 1) {
        autoTable(this.pdfObj, {
          theme: "grid",
          head: [parentTableHeaders],
          body: parentTableData,
          startY,
          margin: { left: 20, right: 20 },
          headStyles: {
            fillColor: [68, 70, 84],
            textColor: 255,
            fontStyle: "bold",
          },
          bodyStyles: {
            fontSize: 10,
            cellPadding: 3,
          },
          styles: {
            lineWidth: 0.2,
          },
        });

        startY = (this.pdfObj as any).lastAutoTable.finalY + 15;

        this.pdfObj.setFontSize(12);
        this.pdfObj.setTextColor(68, 70, 84);
        this.pdfObj.setFont("helvetica", "bold");
        this.pdfObj.text("Registered Programs", 20, startY - 5);
      }

      const pageData = tableData.splice(0, rowsPerPage);

      autoTable(this.pdfObj, {
        theme: "striped",
        head: [tableHeaders],
        body: pageData,
        startY: currentPage === 1 ? startY : 40,
        margin: { left: 20, right: 20 },
        headStyles: {
          fillColor: [68, 70, 84],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 10,
        },
        bodyStyles: {
          fontSize: 9,
          cellPadding: 3,
        },
        styles: {
          lineWidth: 0.2,
          fontSize: 9,
        },
        columnStyles: {
          3: { cellWidth: "auto" },
          4: { cellWidth: "auto" },
        },
      });

      addFooter(this.pdfObj, currentPage, totalPages);
      currentPage++;
    }

    this.pdfObj.save("Trail_Fusion_History_Report.pdf");
  }

  refreshHistoryData(): void {
    const UID = this.parentId;
    if (!UID) {
      this.openSnackBar("Unable to refresh data. UID not found ❌");
      return;
    }

    this.parentPortalService
      .getParentByUID(UID)
      .pipe(
        catchError((error) => {
          console.error("Error refreshing history data:", error);
          this.openSnackBar("Failed to refresh history data ❌");
          return throwError(() => error);
        }),
        finalize(() => {})
      )
      .subscribe((responses: any) => {
        try {
          const apiResponse = JSON.parse(responses.msg);

          if (apiResponse.success === true) {
            this.fetchData.setLocalStorage(responses.msg);
            this.reinitializeHistoryData();
            this.openSnackBar("History data refreshed successfully ✅");
          } else {
            console.warn("API responded with success = false:", apiResponse);
            this.openSnackBar("Failed to refresh history data ❌");
          }
        } catch (e) {
          console.error("Error parsing response:", e);
          this.openSnackBar("Invalid response from server ❌");
        }
      });
  }

  private reinitializeHistoryData(): void {
    this.kids = [];
    this.scheduleData = [];
    this.filteredScheduleData = [];

    this.filterKidsByParentId();
    this.loadSchedules();
    this.loadParentData();
    this.applyFilters();
  }

  private processAttendance(lstAttendance: any[], classSchedules: any[]): void {
    this.scheduleData.forEach((schedule) => {
      if (schedule.isCancelled) {
        schedule.attendanceStatus = "Cancelled";
        return;
      }

      const attendance = lstAttendance.find(
        (att) =>
          att.Class_Schedule__c === schedule.classSchedule &&
          att.Program_Date__c === schedule.programDate &&
          att.Kids__c === schedule.kidsId
      );

      if (attendance) {
        if (attendance.Is_Absent__c) {
          schedule.attendanceStatus = "Absent";
        } else if (attendance.In_Time__c || attendance.Out_Time__c) {
          schedule.attendanceStatus = "Present";
        } else {
          schedule.attendanceStatus = "N/A";
        }
      } else {
        schedule.attendanceStatus = "N/A";
      }
    });

    this.filteredScheduleData = [...this.scheduleData];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openSnackBar(message: string) {
    this._snackBar.open(message, "Close", {
      duration: 2000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }
}
